import { ActionTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { OpenPanelsState } from '@/models/states/open-panels-state';

export const actions: ActionTree<OpenPanelsState, RootState> = {};
